import {connect} from "../../redux/utils";
import {startLoadingDemoData} from "./actions";
import View from "../../View";
import {bindActionCreators} from "redux"
import $ from '../../alias/jquery'
import DemoDataComponent from "./components/DemoDataComponent";
import {DemoDataStageType} from "./constants";
import {getDemoDataStage, getPopupVisible} from "./selectors";

class DemoDataLoaderContainer extends View {
    constructor({
        startLoadingDemoData
    }) {
        super($('body'))

        this.state = {
            demoDataStage: DemoDataStageType.IDLE,
            popupVisible: false,
        }
        this.onStatePropertyBecameValue('popupVisible', false, () => {
            if (this.state.demoDataStage !== DemoDataStageType.ERROR && this.state.demoDataStage !== DemoDataStageType.COMPLETED) {
                this.demoDataLoader.show()
                this.demoDataLoader.refreshStage(this.state.demoDataStage)
            }
        })

        this.onStatePropertyChanged('demoDataStage', demoDataStage => {
            this.demoDataLoader.setState({stage: demoDataStage})
            if (demoDataStage === DemoDataStageType.ERROR || demoDataStage === DemoDataStageType.COMPLETED) {
                this.demoDataLoader.hide()
            }
        })

        this.loadDemoDataCb = startLoadingDemoData
    }

    afterRender() {
        this.demoDataLoader = new DemoDataComponent({}).init($('body'))
        this.loadDemoDataCb()
    }
}

export default connect((state) => ({
    demoDataStage: getDemoDataStage(state),
    popupVisible: getPopupVisible(state),
}), (dispatch) => bindActionCreators({
    startLoadingDemoData
}, dispatch))(DemoDataLoaderContainer)


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/DemoDataLoaderContainer.js